import { writable, type Writable } from "svelte/store";
import type { IHitMetaData } from "@typesAndInterfaces/types";

export const pageNr = writable(1);

export const preventOnMountSearch = writable(false);

export const hits: Writable<IHitMetaData[]> = writable([]);
